import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing, { spacingWithBorder } from '../../../helpers/spacing';
import Image from '../../Image';
import Link from '../../Link';

const borderPx = 1;

type ProductCardContainerProps = {
  displayBackground?: boolean;
};

export const ProductCardContainer = styled.div<ProductCardContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  background-color: ${({ displayBackground }) =>
    displayBackground ? colors.neutral08 : 'initial'};
  position: ${({ displayBackground }) => (displayBackground ? 'relative' : 'initial')};

  margin: ${spacing(1)} 0;

  padding: ${spacingWithBorder(4, borderPx)} ${spacingWithBorder(3, borderPx)};
  border: ${borderPx}px solid ${colors.cardBorder};
  border-radius: ${({ theme }) => `${theme.cardRadius}`};

  ${mediaQuery.tabletLandscape`
    margin: ${spacing(2)} 0;
    padding: ${spacingWithBorder(4, borderPx)};
  `}
`;

export const Heading = styled.h2`
  overflow-wrap: break-word;
  ${fonts.headingMedium}
  text-align: center;
  margin: 0;
`;

export const HeadingLink = styled(Link)`
  margin: 0 auto;
`;

export const CtaWrapper = styled.div`
  margin-top: auto;
  padding-top: ${spacing(4)};
  text-align: center;
`;

export const SecondaryCtaWrapper = styled.div`
  padding-top: ${spacing(2)};
  text-align: center;
`;

export const IconWrapper = styled.div`
  color: ${colors.cardIcon};
  margin: 0 auto ${spacing(2)};
  display: inline-block;
`;

export const Body = styled.p`
  ${fonts.paragraph}
  margin: ${spacing(1)} 0 0;
  width: 100%;
  text-align: center;
`;

export const SecondaryLink = styled(Link)`
  margin-top: ${spacing(2)};
  ${fonts.paragraph};
  text-align: center;
`;

export const StyledImage = styled(Image)`
  width: unset;
  height: 136px;
  max-width: 100%;
  margin-bottom: ${spacing(2)};
`;
